module.exports = __webpack_public_path__ + "media/images/sponsors/sponsor-01@2x-a7351d41c317260179aba34999755b27.png";